import { ResponsivePie } from "@nivo/pie";
import { IOverallDowntimeSummaryPieChartProps } from "./OverallDowntimeSummaryPieChartInterfaces";
import { useMemo } from "react";

const theme = {
    tooltip: {
        container: {
            display: "none",
        },
    },
    labels: {
        text: {
            fontSize: 16,
            fontFamily: "Open Sans",
            fontWeight: 400,
        },
    },
};

export const OverallDowntimeSummaryPieChart = ({
    data,
    pieChartCenteredMetric,
    setHighlight,
}: IOverallDowntimeSummaryPieChartProps) => {
    const fills = useMemo(() => {
        return data.map((dataItem) => ({
            match: {
                id: dataItem.id,
            },
            id: dataItem.name,
        }));
    }, [data]);

    return (
        <ResponsivePie
            colors={{ datum: "data.color" }}
            data={data}
            theme={theme}
            margin={{ top: 20, right: 180, bottom: 60, left: 0 }}
            innerRadius={0.7}
            padAngle={1.2}
            cornerRadius={3}
            activeOuterRadiusOffset={8}
            borderWidth={1}
            borderColor={{
                from: "color",
                modifiers: [["darker", 0.2]],
            }}
            enableArcLinkLabels={false}
            enableArcLabels={false}
            layers={["arcs", "arcLabels", "arcLinkLabels", "legends", pieChartCenteredMetric]}
            fill={fills}
            legends={[]}
            onClick={(data) => {
                setHighlight({ name: data["label"].toString(), value: data["value"] });
            }}
        />
    );
};
